import { Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";

import "./inventoryMobile.styles.scss";

import InventoryMobileDetail from "./InventoryMobileDetail";

import { updateInventories } from "@/redux/actions/inventory.actions";

const InventoryMobile = () => {
	const dispatch = useDispatch();

	const inventories = useSelector((state) => state.inventory.inventories);

	const handleClick = (i) => {
		let newInventories = [...inventories];
		let currentStatus = inventories[i].active;
		newInventories.forEach((element, index) => {
			newInventories[index].active = 0;
		});

		newInventories[i].active = !currentStatus;

		dispatch(updateInventories(newInventories));
	};

	return (
		<>
			<Col
				xs={12}
				className="main-detail"
				style={{
					marginTop: "5px",
					fontSize: "12px",
					textAlign: "center",
				}}
			>
				<Row>
					<Col xs={5}>Producto</Col>
					<Col xs={3}>Stock</Col>
					<Col xs={3}>U.M</Col>
				</Row>
			</Col>
			{inventories.map((inventory, i) => {
				return <InventoryMobileDetail key={i} inventory={inventory} handleClick={handleClick} index={i} />;
			})}
		</>
	);
};

export default InventoryMobile;
